import React, { useEffect, useState } from 'react';
import { ResponsiveGrid, Tab } from '@alifd/next';
import { Row, Col } from 'antd';
import axios from 'axios';
import moment from 'moment';
import styles from './index.module.scss';

const { Cell } = ResponsiveGrid;

const ISOZone = () => {
  const [isoData, setIsoData] = useState([]);
  const [filterData, setFilterData] = useState([]);

  useEffect(() => {
    axios('/ezcon/api/getIsoData', {
      method: 'GET',
      headers: {
        authorization: window.localStorage['feathers-jwt'],
      },
    }).then((res) => {
      console.log(res);
      setIsoData(res.data);
      setFilterData(res.data[0]);
    });
  }, []);

  return (
    <div>
      <Row gutter={[16, 16]}>
        {isoData.length > 0 &&
          isoData.map((item, index) => (
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <div
                className={
                  filterData.name === item.name
                    ? styles.titleClick
                    : styles.title
                }
                key={index}
                onClick={() => {
                  setFilterData(isoData[index]);
                }}
              >
                {item.name}
              </div>
            </Col>
          ))}
      </Row>
      <div className={styles.control}>
        <Row gutter={[16, 16]}>
          {filterData?.children &&
            filterData.children.map((item) => (
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <div className={styles.content}>
                  <div className={styles.contentTitle}>
                    <h2>{item.title}</h2>
                  </div>
                  <div>
                    {item.group.map((groupItem) => (
                      <div className={styles.contentPath}>
                        <a
                          href={groupItem.path}
                          download={
                            moment(groupItem.createAt).format('YYYY年度') +
                            item.title +
                            filterData.name
                          }
                        >
                          {moment(groupItem.createAt).format('YYYY年度')}
                          {filterData.name}(
                          {moment(groupItem.createAt).format('YYYY-MM-DD')})
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
        </Row>
      </div>
    </div>
  );
};

export default ISOZone;
